var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000119813837076930742270000010735148749587845254_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#1C1C1C;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 13,
    cy: 12.6,
    r: 11.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.9,16.1c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.7-0.5-1.2s0.2-0.9,0.5-1.2s0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5 s0.5,0.7,0.5,1.2s-0.2,0.9-0.5,1.2S9.4,16.1,8.9,16.1z M17.1,16.1c-0.5,0-0.9-0.2-1.2-0.5s-0.5-0.7-0.5-1.2s0.2-0.9,0.5-1.2 s0.7-0.5,1.2-0.5c0.5,0,0.9,0.2,1.2,0.5s0.5,0.7,0.5,1.2s-0.2,0.9-0.5,1.2S17.6,16.1,17.1,16.1z M13,24c3.1,0,5.7-1.1,7.8-3.2 S24,16.1,24,13c0-0.5,0-1.1-0.1-1.6c-0.1-0.5-0.2-1-0.4-1.5c-0.5,0.1-1,0.2-1.4,0.3c-0.5,0.1-1,0.1-1.5,0.1c-2.1,0-4.1-0.4-5.9-1.3 s-3.4-2.1-4.7-3.7C9.2,6.9,8.1,8.5,6.8,9.8s-2.9,2.3-4.8,3V13c0,3.1,1.1,5.7,3.2,7.8S9.9,24,13,24L13,24z M13,25.4 c-1.7,0-3.3-0.3-4.8-1c-1.5-0.6-2.8-1.5-3.9-2.6s-2-2.4-2.6-3.9c-0.6-1.5-1-3.1-1-4.8s0.3-3.3,1-4.8s1.5-2.8,2.6-3.9s2.4-2,3.9-2.6 s3.1-1,4.8-1s3.3,0.3,4.8,1c1.5,0.6,2.8,1.5,3.9,2.6c1.1,1.1,2,2.4,2.6,3.9c0.6,1.5,1,3.1,1,4.8s-0.3,3.3-1,4.8 c-0.6,1.5-1.5,2.8-2.6,3.9c-1.1,1.1-2.4,2-3.9,2.6C16.3,25,14.7,25.4,13,25.4z M9.9,2.4c1.1,2.2,2.7,3.9,4.7,4.9c2,1,4,1.5,6,1.5 c0.4,0,0.8,0,1.3-0.1s0.8-0.1,1.2-0.2c-0.9-2-2.2-3.7-4.1-4.8C17.1,2.6,15.2,2,13,2c-0.6,0-1.1,0-1.7,0.1C10.8,2.2,10.3,2.3,9.9,2.4 L9.9,2.4z M2.2,11.2C3.6,10.6,5,9.5,6.5,8.1S8.8,4.9,9,2.7C7.2,3.4,5.7,4.5,4.5,6C3.3,7.5,2.5,9.2,2.2,11.2L2.2,11.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/default_avatar.c09c0e19da40f69168931982f904a956.svg";
export { ForwardRef as ReactComponent };